import React, { forwardRef } from 'react'
import {
  Radio
  // @ts-ignore
} from '@netbasequid/core'
import styled from 'styled-components'
import { useDisplayTheme } from 'hooks/useUiState'

const RadioContainer = styled.div`
  display: inline-flex;
  align-items: center;
  margin-right: 12px;
  gap: 4px;
`

interface RadioWithLabelProps extends React.ComponentProps<'input'> {
  label: React.ReactNode
}

const RadioWithLabel = forwardRef(({ label, ...props }: RadioWithLabelProps, ref) => {
  const mode = useDisplayTheme()
  return (
    <RadioContainer>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <Radio ref={ref} mode={mode} {...props} />
      <span>{label}</span>
    </RadioContainer>
  )
})

export default RadioWithLabel
